/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum CuePointMetadataProperties {
  TRACK_ID = 'track_id',
  TRACK_DISPLAY_TITLE = 'cue_title',
  TRACK_DISPLAY_DURATION = 'cue_time_duration',
  TRACK_ALBUM_NAME = 'track_album_name',
  TRACK_ALBUM_YEAR = 'track_album_year',
  TRACK_ALBUM_PUBLISHER = 'track_album_publisher',
  TRACK_ARTIST_NAME = 'track_artist_name',
  TRACK_COVER_URL = 'track_cover_url',
  AD_ID = 'ad_id',
  AD_DISPLAY_TITLE = 'cue_title',
  AD_DISPLAY_DURATION = 'cue_time_duration',
  AD_LIFECYCLE_STATE = 'ad_type',
  AD_BREAK_SEQUENCE_NUMBER = 'ad_count',
  AD_VAST_DOCUMENT = 'ad_vast',
  AD_VAST_DOCUMENT_URL = 'ad_vast_url',
  SWEEPER_ID = 'sweeper_id',
  SWEEPER_TYPE = 'sweeper_type',
  SWEEPER_TYPE_VALUE_SWEEPER = 'sweeper',
  SWEEPER_TYPE_VALUE_BUMPER = 'bumper',
  SWEEPER_TYPE_VALUE_PROMO = 'promo',
  SWEEPER_TYPE_VALUE_STATION_ID = 'stationid',
  SWEEPER_TYPE_VALUE_LINER = 'liner',
  SWEEPER_TYPE_VALUE_JINGLE = 'jingle',
}
